const DashboardTypes = {
  GET_OPEN_BIDS_PROGRESS: 'DASHBOARD_TYPES.GET_OPEN_BIDS_PROGRESS',
  GET_OPEN_BIDS_SUCCESS: 'DASHBOARD_TYPES.GET_OPEN_BIDS_SUCCESS',
  GET_OPEN_BIDS_ERROR: 'DASHBOARD_TYPES.GET_OPEN_BIDS_ERROR',
  GET_LAST_SEVEN_DAYS_DATA_PROGRESS: 'DASHBOARD_TYPES.GET_LAST_SEVEN_DAYS_DATA_PROGRESS',
  GET_LAST_SEVEN_DAYS_DATA_SUCCESS: 'DASHBOARD_TYPES.GET_LAST_SEVEN_DAYS_DATA_SUCCESS',
  GET_LAST_SEVEN_DAYS_DATA_ERROR: 'DASHBOARD_TYPES.GET_LAST_SEVEN_DAYS_DATA_ERROR',
  GET_AWARDED_BIDS_PROGRESS: 'DASHBOARD_TYPES.GET_AWARDED_BIDS_PROGRESS',
  GET_AWARDED_BIDS_SUCCESS: 'DASHBOARD_TYPES.GET_AWARDED_BIDS_SUCCESS',
  GET_AWARDED_BIDS_ERROR: 'DASHBOARD_TYPES.GET_AWARDED_BIDS_ERROR',
  GET_OPEN_AGING_PROGRESS: 'DASHBOARD_TYPES.GET_OPEN_AGING_PROGRESS',
  GET_OPEN_AGING_SUCCESS: 'DASHBOARD_TYPES.GET_OPEN_AGING_SUCCESS',
  GET_OPEN_AGING_ERROR: 'DASHBOARD_TYPES.GET_OPEN_AGING_ERROR',
  GET_OVERALL_TIMELINE_PROGRESS: 'DASHBOARD_TYPES.GET_OVERALL_TIMELINE_PROGRESS',
  GET_OVERALL_TIMELINE_SUCCESS: 'DASHBOARD_TYPES.GET_OVERALL_TIMELINE_SUCCESS',
  GET_OVERALL_TIMELINE_ERROR: 'DASHBOARD_TYPES.GET_OVERALL_TIMELINE_ERROR',
};

export default DashboardTypes;
